import AlertLevel from "../../../models/alert";
import AlertModal from "../../Shared/AlertModal/AlertModal";
import { FormattedMessage } from "react-intl";

type EcrOnDemandInfoModalProps = {
  show?: boolean;
  onClose: () => void;
  onAgree: () => void;
};

const EcrOnDemandModal = ({
  show,
  onClose,
  onAgree,
}: EcrOnDemandInfoModalProps) => {
  return (
    <AlertModal
      show={show}
      onClose={onClose}
      level={AlertLevel.Info}
      okBtn={{
        text: (
          <FormattedMessage id="ECG_DETAILS.ACCEPT" defaultMessage="✓ ACCEPT" />
        ),
        onClick: onAgree,
      }}
      cancelBtn={{
        text: (
          <FormattedMessage id="ECG_DETAILS.CANCEL" defaultMessage="CANCEL" />
        ),
        onClick: onClose,
      }}
    >
      <p>
        <FormattedMessage
          id="ECG_DETAILS.ECRONDEMAND.MESSAGE"
          defaultMessage={`By selecting "Accept" you agree to send this ECG to a board-certified cardiologist for interpretation and to pay the related charges.`}
          values={{
            br: () => <br></br>,
          }}
        />
        <br />
      </p>
    </AlertModal>
  );
};

export default EcrOnDemandModal;
